
const DEFAULT = 16

export const spacing = (level, unit = 'px') => {
  return `${level * DEFAULT}${unit}`
}

export const MAX_PAGE_WIDTH = '1100px'
